import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, ReferenceParams, Res, UserRoleReference } from 'src/app/models';
import { LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';
import { OrgRoleEditValidator } from './org-role-edit.validation';

@Component({
  selector: 'app-org-role-edit',
  templateUrl: './org-role-edit.component.html',
  styleUrls: ['./org-role-edit.component.css']
})
export class OrgRoleEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  uroles: UserRoleReference[];
  org_id: string;
  positions: any;
  departments: any;
  userData: any;

  form: UntypedFormGroup = this.fb.group({
    users_orgs_roles_id: [null],
    position_id: [null],
    department_id: [null],
    urole_id: [null, this.validator.urole_id]
  });

  @Input() set data(value) {

    if (value != null) {

      this.userData = value;
      this.form.controls.users_orgs_roles_id.setValue(value.users_orgs_roles_id);
      this.form.controls.urole_id.setValue(value.u_role);
      this.form.controls.department_id.setValue(value.department);
      this.form.controls.position_id.setValue(value.position);
      this.org_id = value.org_id;
    }

  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private validator: OrgRoleEditValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.form.get('department_id').valueChanges.subscribe(val => {

        this.form.get('position_id').setValue(null);
        this.getPositions(val);
      })
    );

    this.getRoles();
    this.getDepartments();
    this.userData.position ? this.getPositions(this.userData.department) : this.getPositions();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getRoles(): void {

    let params: ReferenceParams = {
      ref_name: 'uroles_in_orgs',
      filter: {
        org_id: this.org_id
      }
    }

    this.subscriptions.add(
      this.apiUserOrgService.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.uroles = response.result;
        }
      })
    );
  }

  /**
  * 
  */
  getDepartments(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {}
    }

    this.subscriptions.add(
      this.apiUserOrgService.getReferences(params, 'orgs_departments').subscribe((response: Res) => {

        if (response != null) {

          this.departments = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  getPositions(data: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      filter: {
        department_id: data
      }
    }

    this.subscriptions.add(
      this.apiUserOrgService.getReferences(params, 'orgs_positions').subscribe((response: Res) => {

        if (response != null) {

          this.positions = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUserOrgService.updateUserRole(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }
}
